<script>
import { euroCouponsCouponMethods } from '@state/helpers'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'EuroCouponsCouponForm',
  components: {  },
  props: {
    fullform: {
      type: Boolean,
      required: false,
      default: false,
    },
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      action: 'create',
      euroCouponsCouponOptions: [],
      form: {
        url: null,
        expiration_date: null,
        redemption_date: null,
        redeemed_by: null,
        request: null,
        value: null,
        code: null,
        state: null,
      },
    }
  },
  validations: {
    form: {
      expiration_date: { required, },
      redemption_date: {  },
      redeemed_by: {  },
      request: { required, },
      value: { required, },
      code: { required, },
      state: { required, },
    },
  },
  computed: {},

  mounted: function () {
    let context = this
    context.form = {
      ...context.form, ...context.instanceJson,
    }
    if (context.instanceJson.url) {
      context.action = 'update'
      context.getObject()
    } else {
      context.action = 'create'
      context.loading = false
    }
  },

  methods: {
    ...euroCouponsCouponMethods,

    getObject() {
      let context = this
      if (context.action == 'update') {
        const promise = context.fetchEuroCouponsCouponDetail(context.form.url)
        return promise
          .then((data) => {
            context.form = { ...data }
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
          })
      }
    },

    submit() {
      let context = this
      context.submitting = true
      context.$v.form.$touch()
      if (context.$v.form.$invalid) {
        context.submitting = false
        context.$generate_toast(
          context,
          'error',
          context.$t('fill_the_required_fields')
        )
        return
      }
      const promise = context.createUpdateEuroCouponsCoupon(context.form)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `${context.$t('coupon')} ${
              context.action == 'create' ? context.$t('created') : context.$t('updated')
            } ${context.$t('correctly')}`
          )
          setTimeout(() => {
            context.oncomplete(data.url || null)
            context.submitting = false
          }, 2000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="
      action === 'create' ? `${$t('create')} ${$t('coupon')}` : `${$t('update')} ${$t('coupon')}`
    "
    :size="action === 'create' ? 'lg' : 'lg'"
    @hidden="oncancel"
    @ok.prevent="submit"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <!-- 
            Don't touch this generic form, if you need a custom form do 
            a v-else instead and code an alternative form :) 
          -->
          <b-form v-if="fullform" id="form">
            <form-wrapper :validator="$v.form">
                  <b-row>
                    <b-col md="12">
                      <b-form-group name="expiration_date" :label="$t(`expiration_date`)" :description="$t(`expiration_date_help_text`)">
                        <VueCtkDateTimePicker
                          v-model="form.expiration_date"
                          id="expiration_date" :only-date="true"                          format="YYYY-MM-DD"
                        />
                                              </b-form-group>
                      <b-form-group name="redemption_date" :label="$t(`redemption_date`)" :description="$t(`redemption_date_help_text`)">
                        <VueCtkDateTimePicker
                          v-model="form.redemption_date"
                          id="redemption_date" :only-date="true"                          format="YYYY-MM-DD"
                        />
                                              </b-form-group>
                      <form-group name="redeemed_by" :label="$t(`redeemed_by`)" :description="$t(`redeemed_by_help_text`)">
                        <b-form-input
                          type="text"
                          v-model="form.redeemed_by"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                      <form-group name="request" :label="$t(`request`)" :description="$t(`request_help_text`)">
                        <b-form-input
                          type="text"
                          v-model="form.request"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                      <form-group name="value" :label="$t(`value`)" :description="$t(`value_help_text`)">
                        <b-form-input
                          type="number"
                          v-model="form.value"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                      <form-group name="code" :label="$t(`code`)" :description="$t(`code_help_text`)">
                        <b-form-input
                          type="text"
                          v-model="form.code"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                      <form-group name="state" :label="$t(`state`)" :description="$t(`state_help_text`)">
                        <b-form-input
                          type="text"
                          v-model="form.state"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                    </b-col>
                  </b-row>
              <div>
                <form-summary />
              </div>
            </form-wrapper>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> {{ $t('saving') }} </span>
        <span v-else>
          <i class="fe-save"></i>
           {{ $t('save') }}
        </span>
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss">
</style>